export function findInputParent(_input) {
  let parent = _input.parentNode;

  while (parent && !parent.classList.contains("js-input-container")) {
    parent = parent.parentNode;
  }

  return parent;
}

export function findWrapper(element, wrapperClass) {
  let wrapper = element.parentNode;

  while (
    wrapper &&
    wrapper.classList &&
    !wrapper.classList.contains(wrapperClass)
  ) {
    wrapper = wrapper.parentNode;
  }

  return wrapper;
}
